
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 512 512"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M477.671 127.499c-22.89-39.219-53.942-70.272-93.162-93.164C345.278 11.445 302.454.002 256.008.002s-89.281 11.443-128.502 34.333c-39.224 22.888-70.276 53.94-93.168 93.164C11.443 166.725 0 209.56 0 256.001c0 46.443 11.447 89.274 34.333 128.502 22.892 39.216 53.945 70.272 93.168 93.166 39.226 22.886 82.057 34.329 128.502 34.329 46.443 0 89.282-11.443 128.502-34.329 39.22-22.89 70.272-53.946 93.166-93.166C500.557 345.275 512 302.444 512 256.001c0-46.445-11.443-89.283-34.329-128.502zm-72.334 149.834c0 5.776-2.108 10.784-6.336 15.003-4.225 4.219-9.222 6.336-14.999 6.336H128c-5.777 0-10.775-2.117-14.999-6.336-4.222-4.219-6.333-9.227-6.333-15.003v-42.667c0-5.778 2.111-10.778 6.333-14.999 4.223-4.224 9.221-6.335 14.999-6.335h256.004c5.777 0 10.776 2.111 15 6.335 4.224 4.221 6.332 9.221 6.332 14.999v42.667z"}})])
          )
        }
      }
    